<template>
    <div class="bg-lightest radius-normal border-light d-flex flex-column text-center mt-2 py-2">
        <div v-if="isFirstTime" class="d-flex flex-column justify-content-center align-items-center min-height-price-loading">
            <span class="bold">Loading prices</span>
            <loader size="small"></loader>
        </div>

        <div class="d-flex justify-content-start ml-3 mb-2 bold"
            v-if="isPricePerGroup || isPricePerGroupTierPrice">
            {{isPricePerGroup ? 'Price per Group' : 'Price per Category Tier'}}
            <i class="fa fa-info-circle largest color-1 pt-1 ml-2" v-tooltip="'This reservation has special prices depending on the number of people.'"></i>
        </div>

        <div class="d-flex flex-row flex-wrap">
            <div class="col-sm-4 pt-2 pb-2" v-for="personPrice, index in bookingGenderPricesFiltered" :key="index">
                <div v-if="showThisGenderPrice(personPrice)">
                    <div>
                        <div class="font-weight-600">{{ genderPriceName(personPrice) }}</div>
                        <div class="">{{ genderPriceDescription(personPrice) }}</div>
                    </div>

                    <div class="d-flex justify-content-center align-items-center" :class="{'prices-height': reservation.bookingGenderPrices[0].genderPriceType !== 1}" v-if="refreshCategoryPrices">
                        <loader v-if="getIsLoadingCalculations && reservation.bookingGenderPrices[0].genderPriceType !== 1" size="small"></loader>
                        
                        <div class="d-flex flex-column align-itmes-center justify-content-center" v-if="getReservationCalculations && !getIsLoadingCalculations">
                            <div class="dark fs-small bold color-6" style="text-decoration: line-through;" v-if="getPriceGroupOldPrice(personPrice) && isToShowPerGroupPrices">
                                {{ formatPrice(getPriceGroupOldPrice(personPrice)) }} €
                            </div>

                            <div class="dark" v-if="reservation.bookingGenderPrices[0].genderPriceType !== 1">
                                {{ formatPrice(showTicketPrice(findPersonPriceInReservationCalculation(personPrice.id))) }} €
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-center align-items-center" :class="{'prices-height': reservation.bookingGenderPrices[0].genderPriceType !== 1}" v-else>
                        <loader v-if="getIsLoadingCalculations && reservation.bookingGenderPrices[0].genderPriceType !== 1" size="small"></loader>

                        <div class="dark" v-if="(reservation.bookingGenderPrices[0].genderPriceType !== 1) && !getIsLoadingCalculations">
                            {{ formatPrice(showTicketPrice(personPrice)) }} €</div>
                    </div>

                    <div class="mt-2">
                        <button class="btn fs-largest bg-lightest dark border-medium py-1 px-3 h-100" :disabled="readOnly"
                            @click="subtractPerson(personPrice)"> - </button>

                        <input type="text"
                            class="text-center fs-largest darker bg-lighter border-medium radius-normal py-1 px-1 mx-2"
                            :disabled="readOnly" style="width: 3rem;" value="0"
                            @input.lazy="paxManuallyChanged(personPrice), updateCalculations()"
                            v-model.number="personPrice.quantityToBook" v-numInt />

                        <button class="btn fs-largest bg-lightest dark border-medium py-1 px-3 h-100" :disabled="readOnly"
                            @click="addPerson(personPrice)"> + </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { reservationsMixin } from '@/mixins/reservations'
import Loader from '@/tools/loaders/loader1'

export default {
    data() {
        return {
            newQuantityAvalible: null,
            bookingGenderPrices: null,
            refreshCategoryPrices: false,
            firstTime: true
        }
    },
    props: {
        reservation: {
            type: Object
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    created() {
        this.bookingGenderPrices = this.getReservationCalculations.bookingGenderPrices;
    },
    computed: {
        ...mapGetters([
            'getReservation',
            'getAudienceTypeList',
            'getReservationCalculations',
            'getIsLoadingCalculations',
            'getGenderPricePerChannel'
        ]),
        isFirstTime() {
            return this.firstTime;
        },
        isPricePerGroup() {
            return this.isPricePerGroupByFormat(1);
        },
        isPricePerGroupTierPrice() {
            return this.isPricePerGroupByFormat(2);
        },
        isToShowPerGroupPrices() {
            const passengerSettings = this.reservation.event && this.reservation.event.passengerSettings;
            const bookingGenderPrices = this.reservation.bookingGenderPrices || [];

            if (!passengerSettings) {
                return false;
            }

            const isCorrectFormat = passengerSettings.format === 1 || passengerSettings.format === 2;
            const hasQuantityToBook = bookingGenderPrices.some(price => price.quantityToBook > 0);

            return isCorrectFormat && hasQuantityToBook;
        },
        hasAtLeastOneBook() {
            return this.reservations.bookingGenderPrices.some(price => price.quantityToBook > 0);
        },
        bookingGenderPricesFiltered() {
            if (!this.getReservationCalculations ||
                !this.getReservationCalculations.bookingGenderPrices ||
                !this.reservation ||
                !this.reservation.bookingGenderPrices) {
                
                    return [];
            }

            const filteredBookingGenderPrices = this.reservation.bookingGenderPrices;

            // For each object in reservation.bookingGenderPrices, update its grossPrice with the corresponding value from getReservationCalculations
            filteredBookingGenderPrices.forEach(item => {
                const calcItem = this.getReservationCalculations.bookingGenderPrices.find(
                    genderPrice => genderPrice.audienceType === item.audienceType && genderPrice.audienceTypeAssossiation === item.audienceTypeAssossiation
                        && genderPrice.audienceTypeAssossiation === item.audienceTypeGroup && genderPrice.audienceTypeDescription === item.audienceTypeDescription
                );
                
                if (calcItem) {
                    item.grossprice = calcItem.grossprice;
                }
            });

            const [type, ...categories] = filteredBookingGenderPrices;
            if (type && filteredBookingGenderPrices.length > 0 && type.genderPriceType === 1) {
                return categories;
            }
            return filteredBookingGenderPrices;
        },
        isPricePerOrder: function () {
            return this.reservation.bookingGenderPrices.some(gp => gp.genderPriceType === 1);
        },
        calculateTotalPax: function () {
            return this.reservation.bookingGenderPrices.reduce((acc, comp) => {
                if (comp.audienceType) {
                    return acc += comp.quantityToBook
                };

                return acc
            }, 0)
        }
    },
    mixins: [
        reservationsMixin
    ],
    watch: {
        'reservation.agent': {
            handler(newVal, oldVal) {
                if (oldVal.brandName && newVal.brandName && oldVal.brandName != newVal.brandName) {
                    this.refreshCategoryPrices = true;
                }
            },
        }
    },
    methods: {
        ...mapActions([
            'setReservationCalculations'
        ]),
        isPricePerGroupByFormat(expectedFormat) {
            const hasGenderPrice = this.bookingGenderPricesFiltered && this.bookingGenderPricesFiltered.some(price => price.genderPriceType === 3);
            const passengerSettings = this.reservation.event && this.reservation.event.passengerSettings;
            const format = passengerSettings ? passengerSettings.format : null;

            return hasGenderPrice && format === expectedFormat;
        },
        getPriceGroupOldPrice(pricePerson) {
            if (pricePerson.genderPriceType !== 3 ||
                !this.getReservationCalculations ||
                !this.getReservationCalculations.bookingGenderPrices ||
                !this.reservation.event.passengerSettings ||
                (!this.reservation.event.passengerSettings.configurations && !this.reservation.event.passengerSettings.tieredConfigurations)) {

                return false;
            }

            // Searches for the updated price object based on audienceType
            const updatedPricePerson = this.getReservationCalculations.bookingGenderPrices.find(
                genderPrices => genderPrices.audienceType === pricePerson.audienceType
            );
            
            if (!updatedPricePerson) return false;

            // Use currentChannelCommission.channel if it exists and its id is non-zero; otherwise, use creatorUserAccount.salesChannel
            const channelToCompare =
                (this.reservation.currentChannelCommission.channel &&
                this.reservation.currentChannelCommission.channel.id !== 0)
                ? this.reservation.currentChannelCommission.channel.id
                : this.reservation.creatorUserAccount.salesChannel.id;

            // Searches for channel information in the channel list
            const channelInfo = this.getGenderPricePerChannel.channels.find(channel => channel.channelId === channelToCompare);
            
            if (!channelInfo) return false;

            // Map the settings by applying the multiplier and rounding up the price
            const prices = this.getGenderPricePerChannel.passengerSettings.format === 2 ? this.getGenderPricePerChannel.passengerSettings.tieredConfigurations[updatedPricePerson.hashedAudience] : this.getGenderPricePerChannel.passengerSettings.configurations;

            const finalPrices = prices.map(group => ({
                ...group,
                price: this.roundValue(
                    group.price * channelInfo.multiplier,
                    this.getGenderPricePerChannel.roundType
                )
            }));

            // Finds the index in the finalPrices array where the price corresponds to the updated grossprice
            const indexAtualPrice = finalPrices.findIndex(item => item.price === updatedPricePerson.grossprice);
            if (indexAtualPrice === 0) {
                return false;
            }

            if (indexAtualPrice === -1) {
                return finalPrices[finalPrices.length - 1].price;
            }

            return finalPrices[indexAtualPrice - 1].price;
        },
        roundValue(value, roundRuleType) {
            switch (roundRuleType) {
                case 'NearestWholeNumber':
                    return Math.round(value);
                case 'OneDecimalPlace':
                    return Math.round(value * 10) / 10;
                default:
                    return value;
            }
        },
        findPersonPriceInReservationCalculation(id) {
            if (!this.getReservationCalculations.bookingGenderPrices) {
                return false;
            }

            let personPrice = this.getReservationCalculations.bookingGenderPrices.find((e) => { return e.id == id })
            return personPrice
        },
        showThisGenderPrice(personPrice) {
            if (!personPrice || !personPrice.genderPriceType) return false;

            this.firstTime = false;

            return Boolean(this.getAudienceTypeList && ([2, 3].includes(personPrice.genderPriceType) || personPrice.genderPriceType == 1 && (personPrice.isExcludedFromBilling == false || personPrice.audienceType)))
        },
        genderPriceName(personPrice) {
            const obj = this.genderPriceObj(personPrice);
            if (!obj) return 'Ticket';

            return obj.name || 'Ticket';
        },
        genderPriceDescription(personPrice) {
            const obj = this.genderPriceObj(personPrice);
            if (!obj) return null;

            return obj.description || null;
        },
        addPerson(eventGenderPrice) {
            if (!eventGenderPrice.quantityToBook) {
                eventGenderPrice.quantityToBook = 0;
            }

            if (this.reservation.event.availabilityType == 1 || this.totalSelectedTickets < this.reservation.event.quantityAvailable) {
                this.newQuantityAvalible = this.reservation.event.quantityAvailable - this.totalPax

                if (eventGenderPrice.audienceTypeOccupancy >= 2) {
                    if (eventGenderPrice.audienceTypeOccupancy <= this.newQuantityAvalible) {
                        eventGenderPrice.quantityToBook++
                    }
                    else {
                        this.$toasted.info('No more tickets available');
                    }
                }
                else {
                    eventGenderPrice.quantityToBook++
                }
            }
            else {
                this.$toasted.info('No more tickets available');
            }

            // For per-order, trigger calculations only when transitioning from 0 -> 1 pax
            if (this.isPricePerOrder) {
                    this.updateCalculations();
            } else {
                this.updateCalculations();
                this.refreshCategoryPrices = true;
            }

            this.updatePeopleTransport(eventGenderPrice, 'add')
        },
        subtractPerson(eventGenderPrice) {
            if (!eventGenderPrice.quantityToBook) {
                eventGenderPrice.quantityToBook = 0;
            } else {
                if (eventGenderPrice.quantityToBook > 0)
                    eventGenderPrice.quantityToBook--
            }

            // For per-order, trigger calculations only when transitioning from 1 -> 0 pax
            if (this.isPricePerOrder) {
                    this.updateCalculations();
            } else {
                this.updateCalculations();
                this.refreshCategoryPrices = true;
            }

            this.updatePeopleTransport(eventGenderPrice, 'remove')
        },
        updatePeopleTransport(event, action) {
            // Update transport in the present reservation
            this.reservation.bookingComponents.forEach(item => {
                // We validate if they are transports and if any of them has a quantity (meaning that it has already been added previously)
                if (item.component.componentType === 1 && item.quantity > 0) {
                    const totalPax = this.calculateTotalPax;
                    const availableSeats = item.originalQuantity - item.quantityBooked;

                    if (action === 'add') {
                        // Only increments if seats are unlimited and if has costumers without transport and seats available
                        if (item.originalQuantity === 0 || item.quantityAvailable > 0 && item.quantity < item.originalQuantity) {
                            item.quantity++;
                            if (item.originalQuantity !== 0) item.quantityAvailable--;
                        } else {
                            // If all the seats are occupied, display informative message
                            this.$toasted.error('No more seats available!', { duration: 5000 });
                        }
                    } else if (action === 'remove') {
                        if (item.quantity > 0 && item.quantityAvailable >= 0) {
                            // If transport is limited and the total number of people >= the number of seats available
                            if (item.originalQuantity !== 0 && totalPax >= availableSeats) {
                                item.quantity = availableSeats;

                                if (totalPax > availableSeats && event.quantityToBook >= 0) {
                                    this.$toasted.error('No more seats available!', { duration: 5000 });
                                } else if (totalPax === item.quantity && event.quantityToBook >= 0) {
                                    this.$toasted.success('All pax with transport!', { duration: 5000 });
                                }
                            } else {
                                item.quantity--;
                                if (item.originalQuantity !== 0) item.quantityAvailable++;
                            }
                        }
                    }
                }
            });

            this.updateCalculations()
        },
        updateCalculations() {
            // For per-order products, backend expects the base line to have quantity 1
            // even if only category lines are being incremented in the UI.
                if (this.isPricePerOrder) {
                    const totalPax = this.calculateTotalPax;
                    // Find the Ticket object
                    const findTicket = this.reservation.bookingGenderPrices.find(gp => gp.audienceType === null);
                    const ticketQuantityToBooked = findTicket.quantityToBook;

                    if (totalPax > 0 && findTicket && ticketQuantityToBooked === 0) {
                        findTicket.quantityToBook = 1;
                    } else if (totalPax === 0) {
                        findTicket.quantityToBook = 0;
                    }
                }

            this.setReservationCalculations(this.reservation);
        }
    },
    components: {
        Loader
    }
}
</script>

<style lang="scss" scoped>
    .prices-height {
        min-height: 2.5rem;
    }

    .min-height-price-loading {
        min-height: 9.8rem;
    }
</style>



// WEBPACK FOOTER //
// PersonTicketSelector.vue?5e1db80c